import React, { useEffect, useState } from 'react';
import firebase from "firebase/app";
import * as firebaseui from "firebaseui";
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import "firebase/auth";
import { Alert } from 'react-bootstrap-v5'
import Guest from '@/Layouts/Guest';

const firebaseConfig = {
    apiKey: process.env.MIX_FIREBASE_API_KEY,
    authDomain: process.env.MIX_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.MIX_FIREBASE_PROJECT_ID,
    storageBucket: process.env.MIX_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.MIX_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.MIX_FIREBASE_APP_ID,
}

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig)
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.NONE)
}

const uiConfig = {
    signInFlow: 'popup',
    signInSuccessUrl: '/',
    signInOptions: [
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
        {
            provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            clientId: process.env.MIX_GOOGLE_CLIENT_ID,
        },
        firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        firebase.auth.TwitterAuthProvider.PROVIDER_ID,
    ],
    credentialHelper: firebaseui.auth.CredentialHelper.GOOGLE_YOLO,
    tosUrl: process.env.MIX_FIREBASE_UI_TOS,
    privacyPolicyUrl: process.env.MIX_FIREBASE_UI_PRIVACY,
}

uiConfig.callbacks = {
    signInSuccessWithAuthResult: function (authResult, redirectUrl) {
        // console.log(authResult, redirectUrl)
        return false
    },
    uiShown: function () {
        console.log('firebaseui widget shown')
    },
}

export default function Login({ app, return_url }) {
    const [user, setUser] = useState(null)
    const [message, setMessage] = useState(null)

    useEffect(() => {
        firebase.auth().onAuthStateChanged(async (user) => {
            console.log('onAuthStateChanged', user)
            if (!user) {
                return
            }

            if (!user.email) {
                firebase.auth().signOut()
                setMessage('Email is required')
                return
            }

            // if (!user.emailVerified && user.providerData[0].providerId == firebase.auth.EmailAuthProvider.PROVIDER_ID) {
            //     await user.sendEmailVerification()
            //     setMessage('Please verify your email')
            //     return
            // }
            setUser(user)

            const token = await user.getIdToken()
            const res = await axios.post('/account/login', { token })
            if (res.data.user) {
                console.debug(return_url)
                if (return_url) {
                    window.location.href = return_url
                }
            }
        })
    }, [])

    return (
        <Guest app={app}>
            {user && (
                <Alert variant="info">
                    Signing in...
                </Alert>
            )}

            {message && (
                <Alert variant="info">
                    {message}
                </Alert>
            )}

            {!user && (
                <StyledFirebaseAuth uiCallback={ui => ui.disableAutoSignIn()} uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
            )}
        </Guest>
    )
}